module.exports = __webpack_public_path__ + "static/img/card-front.8b9c3a7f.png";